import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { HomePageService } from '../home-page/home-page.service';

@Component({
  selector: 'app-home-page-parent',
  templateUrl: './home-page-parent.component.html',
  styleUrls: ['./home-page-parent.component.scss']
})
export class HomePageParentComponent implements OnInit, OnDestroy {
  private screenWidth = window.innerWidth;
  private preloadLinks: HTMLLinkElement[] = [];

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = event.target.innerWidth;
    this.checkWidth();
  }

  constructor(public homePageService: HomePageService) {
    this.homePageService.isHomePage = true;
  }

  ngOnInit() {
    this.checkWidth();
    this.addPreloadLink('./assets/images/header-parent-desktop.jpg', 'image', undefined, '(min-width: 768px)');
    this.addPreloadLink('./assets/images/header-parent-mobile.jpg', 'image', undefined, '(max-width: 767px)');
  }

  ngOnDestroy() {
    this.removePreloadLinks();
  }

  private checkWidth() {
    this.homePageService.isMobileDevice = this.screenWidth < 768;
  }

  scrollToDescriptionSection() {
    const input = document.getElementById('discover');
    if (input !== null) {
      window.scroll({
        top: input.offsetTop,
        behavior: 'smooth'
      });
    }
  }

  private addPreloadLink(href: string, as: 'video' | 'image', type?: string, media?: string) {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = as;
    link.href = href;
    if (type) {
      link.type = type;
    }
    if (media) {
      link.media = media;
    }
    document.head.appendChild(link);
    this.preloadLinks.push(link);
  }

  private removePreloadLinks() {
    this.preloadLinks.forEach((link) => link.remove());
    this.preloadLinks = [];
  }
}
